import React from 'react';
// import { Link } from 'react-router-dom'

const Loading = () => (
	<div className="loading">
		<div className="loading-inner">
			<div className="preloader-wrapper big active">
				<div className="spinner-layer">
					<div className="circle-clipper left">
						<div className="circle"></div>
					</div><div className="gap-patch">
						<div className="circle"></div>
					</div><div className="circle-clipper right">
						<div className="circle"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/js/components/Loading.js